export default __webpack_public_path__ + "static/media/coal-powerplant.5b45a899.svg";